import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import LoginnewIcon from "../../../../media/images/icons/login-newsvg";
import { Link } from "react-router-dom";

export default function LoginLink() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        marginTop: "32px",
        marginBottom: "80px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
      }}
    >
      <Typography
        sx={{
          fontSize: "13px",
          color: "textColor.main",
          fontWeight: "600",
        }}
      >
        قبلا ثبت نام کرده اید؟
      </Typography>

      <Link
        to={"/login"}
        style={{
          display: "flex",
          alignItems: "center",
          backgroundColor: theme.palette.primary.main,
          padding: "4px",
          borderRadius: "8px",
        }}
      >
        <Typography
          sx={{
            fontSize: "13px",
            color: "background.default",
            fontWeight: "600",
          }}
        >
          ورود به برنامه
        </Typography>
        <LoginnewIcon color={theme.palette.background.default} />
      </Link>
    </Box>
  );
}
